import { useMutation, useQuery } from "@tanstack/react-query";
import { ksHistoriqueAssurancesQK } from "../query-keys";
import { assurancesService } from "../services/assurances.service";

export const useHistoriqueAssurances = () => {
  return useQuery({
    queryKey: [ksHistoriqueAssurancesQK],
    queryFn: assurancesService.getHistorique,
  });
};

export const useAttestationAssuranceFile = () =>
  useMutation({
    mutationFn: (assuranceId: string) => assurancesService.getAttestationFile(assuranceId),
  });
